import React, {useRef} from 'react'
import {useLocation, useParams, useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next'
import {LeftOutlined} from '@ant-design/icons';

import Layout from '@/components/Layout'
import ProductList from '@/components/ProductList';
import './index.less';

export default function BrandProducts() {
  const {category2} = useParams()
  const location = useLocation()
  const {t} = useTranslation()
  const productsContentRef = useRef(null)
  const orderCartProductList = useSelector(state => state.cart.orderCartProductList)
  const navigate = useNavigate()
  const savedBrand = JSON.parse(sessionStorage.getItem(`brand_category_${category2}`) || '{}')
  const title = location.state?.title || savedBrand.title || t('Brand')
  const products = location.state?.products || savedBrand.products || []
  
  const handleBackClick = () => {
    navigate(-1)
  }
  
  return (
    <Layout>
    {/*<div className={'brand-list-back-container'} onClick={handleBackClick}>
        <LeftOutlined className={'brand-list-back-icon'} />
        <div className={'brand-list-back-title overflow-ellipsis-1'}>
          Go Back
        </div>
      </div>*/}
      <ProductList
        ref={productsContentRef}
        rootPath={`/brandProducts/${category2}`}
        scrollTop={0}
        isEditOrder={false}
        isShowSearch={false}
        initialProducts={products}
        cartProductList={orderCartProductList}
      />
    </Layout>
  )
}
